import type { ReactNode } from 'react';
import { cn } from './cn.js';
import { Mascot } from './Mascot.js';

export interface NexSaysProps {
  children: ReactNode;
  title?: string;
  /** Zeigt Nex im Denk-Modus — für laufende KI-Aufrufe. */
  thinking?: boolean;
  /** KI war nicht verfügbar: Nex sagt das, statt dass ein roher Fehler erscheint. */
  degraded?: boolean;
  className?: string;
}

/**
 * Einheitliche Bühne für alles, was die KI sagt (#84).
 *
 * Ohne sie sähe jede KI-Ausgabe in jedem Bereich anders aus. Mit ihr ist immer dieselbe
 * Figur der Absender — das macht erkennbar, was von der KI stammt und was der Nutzer selbst
 * eingetragen hat.
 */
export function NexSays({ children, title, thinking, degraded, className }: NexSaysProps) {
  return (
    <div
      className={cn(
        'flex gap-3 rounded-2xl border p-4',
        degraded ? 'border-line bg-raise' : 'border-gold/25 bg-gold/[0.06]',
        className,
      )}
    >
      <div className="shrink-0">
        <Mascot mood={degraded ? 'sad' : thinking ? 'thinking' : 'happy'} size={40} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs font-medium text-gold">
          {title ?? (thinking ? 'Nex denkt nach …' : 'Nex meint')}
        </div>
        <div className="mt-1 text-sm leading-relaxed text-text-dim">{children}</div>
      </div>
    </div>
  );
}
